import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo1 from "../assets/img/core-img/logo-1.png";

/* ---------- overlay + copyright-bar styles ---------- */
const footerStyles = `
  .footer-area.bg-img { position: relative; }
  .footer-area.bg-img::before {
    content:''; position:absolute; inset:0;
    background:rgba(0,0,0,.95)!important; z-index:1;
  }
  .footer-content-area,
  .footer-area *, .footer-area .container { position:relative; z-index:2; }

  .footer-logo img{max-width:275px!important;height:auto!important;width:auto!important;}
  @media(max-width:768px){.footer-logo img{max-width:230px!important;}}

  /* copyright bar */
  .footer-bottom-bar{
    background:#0c0f29;
    color:#fff;
    text-align:center;
    padding:12px 0;
    font-size:.875rem;
  }
`;

export default function Footer() {
  /* inject styles once */
  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.dataset.footerStyles = "true";
    styleEl.textContent = footerStyles;
    document.head.appendChild(styleEl);
    return () => styleEl.remove();
  }, []);

  return (
    <footer className="footer-area bg-img">
      {/* ─── Main footer content ─── */}
      <div className="footer-content-area map-before">
        <div className="container">
          <div className="row">
            {/* About & Social */}
            <div className="col-12 col-lg-4 col-md-6">
              <div className="footer-copywrite-info">
                <div className="copywrite_text fadeInUp" data-wow-delay="0.2s">
                  <div className="footer-logo">
                    <Link to="/">
                      <img src={logo1} alt="Ardent Translations Logo" />
                    </Link>
                  </div>
                  <p>
                    Your partner in professional translation and localization
                    services, bridging communication across the globe.
                  </p>
                </div>
                <div
                  className="footer-social-info fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <a href="https://facebook.com/ardenttranslations" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" /></a>
                  <a href="https://twitter.com/ardenttranslations" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a>
                  <a href="https://linkedin.com/company/ardenttranslations" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin" /></a>
                </div>
              </div>
            </div>

            {/* Services */}
            <div className="col-12 col-lg-3 col-md-6">
              <div className="contact_info_area d-sm-flex justify-content-between">
                <div
                  className="contact_info mt-s text-center fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <h5>Services</h5>
                  <Link to="/services"><p>Document Translation</p></Link>
                  <Link to="/services"><p>Website Localization</p></Link>
                  <Link to="/services"><p>Voiceover &amp; Subtitling</p></Link>
                  <Link to="/services"><p>DTP Services</p></Link>
                  <Link to="/services"><p>CAD Services</p></Link>
                  <Link to="/services"><p>Content Writing</p></Link>
                </div>
              </div>
            </div>

            {/* Navigate */}
            <div className="col-12 col-lg-2 col-md-6">
              <div className="contact_info_area d-sm-flex justify-content-between">
                <div
                  className="contact_info mt-s text-center fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h5>Navigate</h5>
                  <Link to="/"><p>Home</p></Link>
                  <Link to="/about-us"><p>About Us</p></Link>
                  <Link to="/services"><p>Services</p></Link>
                  <Link to="/multilingual"><p>Multilingual</p></Link>
                  <Link to="/faq"><p>FAQ</p></Link>
                  <Link to="/contact-us"><p>Contact Us</p></Link>
                </div>
              </div>
            </div>

            {/* Contact */}
            <div className="col-12 col-lg-3 col-md-6">
              <div className="contact_info_area d-sm-flex justify-content-between">
                <div
                  className="contact_info mt-s text-center fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h5>Contact Us</h5>
                  <p>45 ICON, Baner Road, Pune 411045, India</p>
                  <p>+91 89378 33310</p>
                  <p>info@ardenttranslations.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── Copyright bar ─── */}
      <div className="footer-bottom-bar">
        © {new Date().getFullYear()} Ardent Translations | All&nbsp;Rights&nbsp;Reserved
      </div>
    </footer>
  );
}
